import { useEffect } from 'react';
import RadioGroup from '../../../ui/radio-group';
import Input from '../../../ui/input';
import Text from '../../../ui/text';
import { useFormContext } from "react-hook-form";
import { useTranslation } from 'react-i18next';

function LongTermCare() {
  const { t } = useTranslation();
  const { 
    watch,
    register,
    control,
    resetField,
    formState: { errors },
  } = useFormContext();

  const watchLongTermCare = watch('longTermCare');

  useEffect(() => {
    if (!watchLongTermCare) {
      resetField('facilityName');
      resetField('facilityAddress');
      resetField('facilityPhone');
    }
  }, [watchLongTermCare]);

  return (
    <section className="w-full">
      <h2 className="text-2xl font-semibold leading-none text-secondary">
        <Text>Long Term Care *</Text>
      </h2>
      <div className='w-full flex flex-col justify-start items-start mt-5'>
        <RadioGroup
          control={control}
          name='longTermCare'
          size='sm'
          options={[
            { label: <Text>Yes</Text>, value: true },
            { label: <Text>No</Text>, value: false }
          ]} 
          isInvalid={!!errors?.longTermCare}
          errorMessage={errors?.longTermCare?.message || null}
        />
      </div>
      {watchLongTermCare && (
        <div className="grid grid-cols-12 gap-5 mt-5">
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='facilityName'>Facility Name *</Text>
            <Input
              {...register('facilityName')}
              size='sm'
              label={<Text>Facility Name</Text>}
              placeholder="-"
              errorMessage={errors?.facilityName?.message || null}
              isInvalid={errors?.facilityName ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='facilityAddress'>Facility Address *</Text>
            <Input
              {...register('facilityAddress')}
              size='sm'
              label={<Text>Facility Address</Text>}
              placeholder="-"
              errorMessage={errors?.facilityAddress?.message || null}
              isInvalid={errors?.facilityAddress ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='facilityPhone'>Facility Phone *</Text>
            <Input
              {...register('facilityPhone')}
              size='sm'
              label={<Text>Facility Phone</Text>}
              placeholder={t('0123456789')}
              errorMessage={errors?.facilityPhone?.message || null}
              isInvalid={errors?.facilityPhone ? true : false}
            />
          </div>
        </div>
      )}
    </section>
  );
}

export default LongTermCare;